import { observer } from "@legendapp/state/react";
import UserIcon from "@simble/shared/assets/icons/finuslugi/user-icon.svg?react";
import LogoColorFull from "@simble/shared/assets/icons/partner/logo-color-f.svg?react";
import { cn } from "@simble/shared/lib/cn";
import { useNavigate } from "@tanstack/react-router";
import type React from "react";
import { store } from "@/store/local-store";

const Header = observer(
  ({
    headerContent = null,
    className,
    isDisabledClick = false,
  }: {
    headerContent?: React.ReactNode;
    className?: string;
    isDisabledClick?: boolean;
  }) => {
    const navigate = useNavigate();
    const userName = store.userName.get();

    const handleNavigateToHome = () => {
      navigate({ to: "/" });
    };

    return (
      <header className={cn(className)}>
        <div className="mx-auto w-full max-w-[1028px] px-4 md:px-2">
          <div className="relative flex w-full flex-nowrap items-center justify-between py-5.5">
            <button
              className={cn("relative flex cursor-pointer flex-col gap-1", isDisabledClick && "pointer-events-none")}
              onClick={isDisabledClick ? undefined : () => handleNavigateToHome()}
              type="button"
            >
              <LogoColorFull className="h-7 w-[118px]" />
              <p className="caption-regular absolute top-[calc(100%+4px)] text-secondary">Партнеры</p>
            </button>
            {userName ? (
              <div className="flex items-center gap-2">
                <UserIcon className="size-6" />
                <span className="body-regular text-[16px] text-secondary">{userName}</span>
              </div>
            ) : null}
          </div>

          {headerContent}
        </div>
      </header>
    );
  }
);

export default Header;
